<template>
    <c-dialog ref="dialog" height="800" width="650" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="企业类型" required>
                <c-radio-group name="comproperty" v-model="comproperty" :options="compropertyOptions"></c-radio-group>
            </c-form-item>
            <c-form-item label="认证类型" required>
                <c-radio-group name="authType" v-model="authType" :options="authTypeOptions"></c-radio-group>
            </c-form-item>
            <c-form-item label="企业名称" required tip="最多输入50个字符">
                <c-input name="companyName" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="企业地址">
                <c-input name="companyAddress" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="统一社会信用" required>
                <c-input name="uniCredit" maxlength="150" ></c-input>
            </c-form-item>
            <c-form-item label="营业执照号到期时间">
                <c-datetime name="expLicense" type="date" format="yyyy-MM-dd"></c-datetime>
            </c-form-item>
            <c-form-item label="营业执照号" :required="authType == 1">
                <c-input name="businessLicense" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="组织机构代码" :required="authType == 1">
                <c-input name="organizationCode" maxlength="150" :required="authType == 1"></c-input>
            </c-form-item>
            <c-form-item label="税务登记证" :required="authType == 1">
                <c-input name="taxRegister" maxlength="150" :required="authType == 1"></c-input>
            </c-form-item>
            <c-form-item label="法人姓名" required>
                <c-input name="legalName" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="法人证件类型" required>
                <c-radio-group name="identityType" v-model="identityType" :options="identityTypeOptions"></c-radio-group>
            </c-form-item>
            <c-form-item label="法人证件号（身份证号）" required>
                <c-input name="legalIds" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="法人手机号" required>
                <c-input name="legalPhone" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="银行账户类型" required>
                <c-radio-group name="acctType" v-model="acctType" :options="acctTypeOptions"></c-radio-group>
            </c-form-item>
            <c-form-item label="银行卡号" required>
                <c-input name="accountNo" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="银行预留电话" required>
                <c-input name="phone" maxlength="11"></c-input>
            </c-form-item>
            <c-form-item label="开户银行名称" :required="this.acctType == 1" tip="可用银行名称参见:https://cloud.allinpay.com/ts-cloud-dev-web/#/apiCenter/index?params=y&key=303">
                <c-input name="parentBankName" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="开户行支行名称" :required="this.acctType == 1" tip="如：“中国工商银行股份有限公司北京樱桃园支行”">
                <c-input name="bankName" maxlength="150"></c-input>
            </c-form-item>
            <c-form-item label="支付行号" :required="this.acctType == 1" tip="支付行号，12位数字,查询支付行号可访问网站：https://www.lianhanghao.net">
                <c-input name="unionBank" maxlength="150"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name:'allinpay_set_company',

    data() {
        return {
            userId:0,
            editFlag:false,
            phone: '',
            verify_code: '',
            comproperty:2,
            compropertyOptions:[
                {name: '个体工商户', value: 2, color: 'blue'},
                {name: '企业', value: 1, color: 'green'},
                {name: '事业单位', value: 3, color: 'black'}
            ],
            authType:2,
            authTypeOptions:[
                {name: '一证', value: 2, color: 'blue'},
                {name: '三证', value: 1, color: 'green'},
            ],
            identityType:1,
            identityTypeOptions:[
                {name: '身份证', value: 1, color: 'green'}
            ],
            acctType:0,
            acctTypeOptions:[
                {name: '对私', value: 0, color: 'green'},
                {name: '对公', value: 1, color: 'green'}
            ]
        }
    },
    computed: {

    },
    mounted() {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                this.userId = data.user_id;
            }
            this.$refs.form.set({
                comproperty:this.comproperty,
                authType:this.authType,
                identityType:this.identityType,
                acctType:this.acctType
            });
            //填充form表单
            this.$refs.dialog.open({
                title: '企业账户实名认证'
            });
        },
        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/allinpay/member/set/company_info',
                rule: {
                    comproperty: '请选择企业类型',
                    authType: '请选择企业认证方式',
                    companyName: '请填写企业名称',
                    uniCredit: '请填写统一社会信用',
                    businessLicense: [{
                        type: 'empty',
                        message: '请填写营业执照号',
                        skip: () => {
                            return this.authType != 1;
                        }
                    }],
                    organizationCode: [{
                        type: 'empty',
                        message: '请填写组织机构代码',
                        skip: () => {
                            return this.authType != 1;
                        }
                    }],
                    taxRegister: [{
                        type: 'empty',
                        message: '请填写税务登记证',
                        skip: () => {
                            return this.authType != 1;
                        }
                    }],
                    legalName: '请填写法人姓名',
                    identityType: '请选择法人证件类型',
                    legalIds: '请填写法人证件号',
                    legalPhone: '请填写法人法人手机号',
                    acctType: [{
                        type: 'function',
                        fun: (value, data) => {
                            /**
                             * 企业性质=1-企业/3-事业单位，默认1-对公，      不支持上送0-对私
                             * 企业性质=2-个体工商户，支持上送0-对私/1-对公，不填默认1-对公
                             */
                            return this.comproperty == 2 || (this.comproperty != 2 && value == 0)
                        },
                        message: '企业/事业单位不支持“对私”'
                    }],
                    accountNo: '请填写对认证银行卡号',
                    phone: '请填写银行预留电话',
                    parentBankName: [{
                        type: 'empty',
                        message: '请填写开户银行名称',
                        skip: () => {
                            return this.acctType != 1;
                        }
                    }],
                    bankName: [{
                        type: 'empty',
                        message: '请填写开户行支行名称',
                        skip: () => {
                            return this.acctType != 1;
                        }
                    }],
                    unionBank: [{
                        type: 'empty',
                        message: '请填写支付行号',
                        skip: () => {
                            return this.acctType != 1;
                        }
                    }]
                },
                dataFormatter: data => {
                    data.client_user_id = this.userId;  //操作用户ID
                    data.acctType = this.acctType;                  //账户类型 0- 对私 1- 对公
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '提交成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    if (code != 200) {
                        this.$confirm({
                            message: msg,
                            buttonName: '我知道了',
                            cancelButton: false,
                            resolve: () => {
                            }
                        })
                        return false;
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
</style>